import { FILENAME_VALIDATE_REGEX } from '@nexxt/common/constants';
/**
 * Get code from search params
 *
 * @param {String} data
 */
export function getCode(data) {
    if (!data) return null;

    return data.split('?code=')[1];
}

/**
 * Get code from search params
 *
 * @param {String} data
 */
export function getToken(data) {
    if (!data) return null;

    return data.split('?token=')[1];
}

/**
 * Split pathname
 *
 * @param {String} data
 */
export function splitPathname(path) {
    if (!path) return null;

    return path.split('/')[2];
}

/*
 * Filter piped options
 *
 * @param pipingQuestions array
 * @param questions array
 */
export function getFilteredOption(options: any[], questions) {
    const questionObject = {};
    questions.forEach((q) => {
        questionObject[q.id] = q;
    });
    return (options || []).map((value) => {
        const option = questionObject[value.id];
        return {
            ...option,
            id: value.id,
            reversePiping: value.reversePiping || false
        };
    });
}

/**
 * Parse youtube vedio id
 * @param url string
 */
export function matchYoutubeUrl(url) {
    if (!url) return null;

    const p =
        /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
    const matches = url.match(p);
    if (matches) {
        return matches[1];
    }
    return false;
}

/**
 * Build supplied string by interpolating properties inside delimiters('{ }') with the given parameters.
 *
 * @example
 * interpolate(':name is here.', {name: 'Barbara'})
 * => 'Barbaba is here.'
 *
 * @param {string} str
 * @param {object} params
 * @returns {string}
 */
export function interpolate(str, params) {
    let formattedString = str;

    for (const [key, value] of Object.entries(params)) {
        const val = value || '';

        formattedString = formattedString.replace(
            new RegExp(':' + key, 'gi'),
            val.toString()
        );
    }

    return formattedString;
}

/**
 * Parse string from react router location
 *
 * @param {Object} value
 * @return {string}
 */
export function parseId(value) {
    const word = value.split('/');
    return word[word.length - 1];
}

export function clearLocationState(history, location): void {
    history.replace({
        pathname: location.pathname,
        state: {},
        search: location.search
    });
}

export function getFilenameWithoutExtension(filename): string {
    try {
        return filename.split(FILENAME_VALIDATE_REGEX)[1];
    } catch (err) {
        return filename;
    }
}
